export function isJWTExpired(token: string) {
  if (!token) return true
  try {
    const expiry = JSON.parse(atob(token.split('.')[1])).exp as number
    const now = Math.floor(Date.now() / 1000)
    return now >= expiry
  } catch {
    return true
  }
}